import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { DateType, DateTypeEnum } from '../../hooks/types';

export type DateOption = {
    text: string;
    searchValue: DateType;
};

export const DATE_OPTIONS = [
    {
        text: 'default',
        searchValue: DateTypeEnum.CURRENT_FUTURE,
    },
    {
        text: 'Today',
        searchValue: DateTypeEnum.TODAY,
    },
    {
        text: 'Tomorrow',
        searchValue: DateTypeEnum.TOMORROW,
    },
    {
        text: 'This Weekend',
        searchValue: DateTypeEnum.THIS_WEEKEND,
    },
    {
        text: 'This Month',
        searchValue: DateTypeEnum.THIS_MONTH,
    },
];

export type DateTranslations = {
    [key: string]: GenericLazyString;
};

export const DATE_TRANSLATIONS: DateTranslations = {
    default: gettext('Date'),
    Today: gettext('Today'),
    Tomorrow: gettext('Tomorrow'),
    'This Weekend': gettext('This Weekend'),
    'This Month': gettext('This Month'),
};
